<template>
  <div
    class="building-btn"
    :style="{
      top: data.position.y + 'px',
      left: data.position.x + 'px',
    }"
    @click="clickHandle(data.id)"
  >
    <div class="title">{{ data.text }}</div>
  </div>
  <Modal :show="buildingDialog" :data="buildingData" @close="handleCloseProject" />
</template>
<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted, onBeforeUnmount, reactive } from 'vue';
import Modal from './Modal.vue';

const router = useRouter();

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});
// 动画

const clickHandle = () => {
  if (props.data.modal) {
    buildingDialog.value = true;
  }
  if (props.data.goWorkShop) {
    router.push('/index/workshop');
  }
};

const buildingDialog = ref(false);
const buildingData = reactive({
  title: '',
  imgUrl: '',
  content: '',
});
const handleCloseProject = () => {
  buildingDialog.value = false;
};
onMounted(() => {});
onBeforeUnmount(() => {});
</script>
<style scoped lang="scss">
.building-btn {
  position: absolute;
  width: 151px;
  height: 154px;
  background: url(@/assets/images/Safe/icon_btn_2.png);
  background-size: 100% 100%;
  transform-origin: center center;
  cursor: pointer;
  z-index: 3;
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
  .title {
    margin-top: 7px;

    text-align: center;
    white-space: nowrap;
  }
}
</style>
